import React from 'react';
import { Box, Typography } from '@mui/material';

// Simple Thank You page component
export default function ThankYou({ title = 'Thank you!', message = 'Our team will contact you soon.' }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '80vh',
        backgroundColor: '#f5f6fa',
        p: 2,
      }}
    >
      <div className="card shadow-sm border-0" style={{ maxWidth: 420, width: '100%', borderRadius: '1rem' }}>
        <div className="card-body p-4 text-center">
          <Typography variant="h5" sx={{ fontWeight: 700, color: '#222', mb: 2 }}>
            {title}
          </Typography>
          <Typography variant="body1" sx={{ color: '#555', mb: 2 }}>
            {message}
          </Typography>
        </div>
      </div>
    </Box>
  );
}
